
<component
  :is="svgComponent"
  v-if="svgComponent"
  :color="color"
  :width="width ?? newSize"
  :height="height ?? newSize"
/>
